import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SwitchpayPaymentUpdateRequest} from '../../../interfaces/switchpay/SwitchpayPaymentUpdateRequest';
import {SwitchpayService} from '../../../services/switchpay/switchpay.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-switchpay-callback',
  templateUrl: './switchpay-callback.component.html',
  styleUrls: ['./switchpay-callback.component.scss']
})
export class SwitchpayCallbackComponent implements OnInit {

  switchpayPaymentUpdateRequest: SwitchpayPaymentUpdateRequest;
  confirmed = false;
  mobile;
  cardSvgEl;

  constructor(private route: ActivatedRoute, private switchpayService: SwitchpayService, private router: Router, private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
          this.switchpayPaymentUpdateRequest = {
            transactionUid: params.transactionUid,
            sessionToken: params.sessionToken,
            success: params.success
          };

          this.switchpayService.validateSwitchpay(sessionStorage.getItem('sessionToken'), this.switchpayPaymentUpdateRequest)
            .subscribe(
              value => {
                console.log('Response : ' + value);
                this.confirmed = true;
                this.navigateToStatus();
              }, (err: HttpErrorResponse) => {
                this.navigateToStatus();
              }
            );
        }
      );
  }


  navigateToStatus() {
    this.router.navigate(
      [`transaction-status`]);
  }

}
